import { Auth } from '@nackle/bridge';
import { ENV } from './environment';

const AUTH_ENDPOINT = `https://${ ENV }api.biw.cloud/v1/id`; 

const auth = new Auth( {
    authority: AUTH_ENDPOINT,
    debug: false
} );

export default auth;